<template>
  <div class="single-answer top-cmp-20">
    <div class="question-title" id="contentItem" ref="contentItem">Passage</div>
    <div class="question-part">
      <div class="que-row">
        <div class="que-col-1">&nbsp;</div>
        <div class="que-col-2">
          <div class="ck-editor">
            <ckeditor
              :read-only="isEditable"
              :editorUrl="editorURL"
              v-model="question.question_text"
              :config="{
                contentsCss: ['body {font-size: 16px;}'],
                toolbarStartupExpanded: false,
              }"
            ></ckeditor>
          </div>
        </div>
      </div>
    </div>
    <div v-for="(subQuestion, subindex) in question.questions" :key="subindex">
      <div class="question-title">Question {{subQuestion.questionNo}}</div>
      <div class="question-part">
        <div class="que-row">
          <div class="que-col-1">&nbsp;</div>
          <div class="que-col-2">
            <div class="ck-editor">
              <ckeditor
                :read-only="isEditable"
                :editorUrl="editorURL"
                v-model="subQuestion.question_text"
                :config="{
                  contentsCss: ['body {font-size: 16px;}'],
                  toolbarStartupExpanded: false,
                  startupFocus: false,
                }"
              ></ckeditor>
            </div>
          </div>
        </div>
      </div>
      <div class="question-title">Answer</div>
      <div class="ans-part">
        <div class="que-row">
          <div class="que-col-1">&nbsp;</div>
          <div class="que-col-2">
            <div class="st-tile">
              <label class="file-title-st">Start Value</label>
              <v-text-field
                v-model="subQuestion.startValue"
                type="number"
                @input="updateAnswer(subQuestion)"
                @keydown.space.prevent
                @paste.prevent
                outlined
                dense
                hide-details
              ></v-text-field>
            </div>
            <div class="st-tile">
              <label class="file-title-st">End Value</label>
              <v-text-field
                v-model="subQuestion.endValue"
                type="number"
                @input="updateAnswer(subQuestion)"
                @keydown.space.prevent
                @paste.prevent
                outlined
                dense
                hide-details
              ></v-text-field>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="question-title">Hints</div>
        <div v-for="(hint,hi) in question.hints" :key="hi" class="ans-part">
            <div class="que-row">
                <div class="que-col-1">
                    <span class="delete-icon">{{hi+1}}.<v-icon   @click="removeHint" >mdi-delete-circle</v-icon></span>
                </div>
                <div class="que-col-2">
                    <div class="ck-editor">
                        <ckeditor :editorUrl="editorUrl"  v-model="hint.text" :config="{contentsCss: ['body {font-size: 16px;}'],toolbarStartupExpanded:false,startupFocus:false}"></ckeditor>
                    </div>
                </div>
            </div>
        </div>
        <div class="que-row add-sl-opction">
            <div class="que-col-1">&nbsp;</div>
            <div class="que-col-2">
                <div v-if="shouldShowAddHint" @click="addNewHint()" class="add-opction">
                    <div class="circle-icon">
                        <v-icon>mdi-plus-circle</v-icon> 
                        <span>Add Hint</span>
                    </div>
                </div>
            </div>
        </div>-->

    <div class="question-title">Solution</div>
    <div class="ans-part">
      <div class="que-row">
        <div class="que-col-1">&nbsp;</div>
        <div class="que-col-2">
          <div class="ck-editor">
            <ckeditor
              :read-only="isEditable"
              :editorUrl="editorURL"
              v-model="question.solution"
              :config="{
                contentsCss: ['body {font-size: 16px;}'],
                toolbarStartupExpanded: false,
                startupFocus: false,
              }"
            ></ckeditor>
          </div>
        </div>
      </div>
    </div>
    <div class="right-align">
      <v-btn
        @click="onNextQuestion({})"
        v-if="showNextButton"
        class="right-btn cust-btn"
        color="primary"
        >{{ question.btnText }}</v-btn
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "Comprehension2QSA",
  props: ["question", "onNextQuestion", "showNextButton", "tab", "isEditable"],
  data() {
    return {};
  },
  mounted() {
    if (!this.question.id) {
      this.question.questions = [];
      this.question.hints = [];
    }
    this.setDefaultData();
    document.getElementById("contentItem").scrollIntoView();
  },
  methods: {
    onRadioChange(options, opt) {
      options.map((x) => {
        if (opt.index === x.index) {
          x.correct_answer = true;
        } else {
          x.correct_answer = false;
        }
        return x;
      });
      this.$forceUpdate();
    },
    addNewHint() {
      this.question.hints.push({
        text: "",
      });
    },
    removeHint(index) {
      this.question.hints.splice(index, 1);
    },
    setDefaultData() {
      this.question.hints =
        this.question && this.question.hints && this.question.hints.length
          ? this.question.hints
          : [{ text: "" }];
      this.question.questions =
        this.question &&
        this.question.questions &&
        this.question.questions.length
          ? this.question.questions
          : [
              {
                question_text: "",
                options: [
                  {
                    index: this.OPTIONS_ABC[0],
                    option_text: "",
                    correct_answer: false,
                  },
                  {
                    index: this.OPTIONS_ABC[1],
                    option_text: "",
                    correct_answer: false,
                  },
                  {
                    index: this.OPTIONS_ABC[2],
                    option_text: "",
                    correct_answer: false,
                  },
                  {
                    index: this.OPTIONS_ABC[3],
                    option_text: "",
                    correct_answer: false,
                  },
                ],
              },

              {
                question_text: "",
                options: [
                  {
                    index: this.OPTIONS_ABC[0],
                    option_text: "",
                    correct_answer: false,
                  },
                  {
                    index: this.OPTIONS_ABC[1],
                    option_text: "",
                    correct_answer: false,
                  },
                  {
                    index: this.OPTIONS_ABC[2],
                    option_text: "",
                    correct_answer: false,
                  },
                  {
                    index: this.OPTIONS_ABC[3],
                    option_text: "",
                    correct_answer: false,
                  },
                ],
              },
            ];
    },
    updateAnswer(subQuestion) {
      // this.question.correct_answer = this.startValue + "##" + this.endValue;
      var startValue = subQuestion.startValue
        ? subQuestion.startValue.toString()
        : "";
      var endValue = subQuestion.endValue
        ? subQuestion.endValue.toString()
        : "";
      subQuestion.correct_answer = startValue + "##" + endValue;
    },
  },
  computed: {
    shouldShowAddHint() {
      return this.question.hints.length < this.OPTIONS_ABC.length;
    },
  },
  watch: {
    question(val) {
      this.setDefaultData();
      document.getElementById("contentItem").scrollIntoView();
    },
    tab(val) {
      this.question.questions = [];
      this.question.hints = [];
      this.setDefaultData();
    },
  },
};
</script>
